<div class="dataset-checkboxes" *ngIf="dataset && selectedItems$ | async as selected">
  <ng-container *ngFor="let item of dataset.items; let i = index">
    <mat-checkbox [tid]="getTid(item)" [value]="item" [checked]="contains(selected, item)" (change)="toggleItem(item)"></mat-checkbox>
    <app-form-label (click)="toggleItem(item)">
      {{ dataset.getLabel(item) }}
      <span *ngIf="checkCounts && checkCounts.length > 0">({{ countItems(i) }})</span>
    </app-form-label>
  </ng-container>
</div>
